<template>
<div class="chapter">
<div class="inner_page">
<section class="minitoc notoc" data-pdf-bookmark="Newsletter Sign-up" data-type="preface" epub:type="preface"><div class="preface" id="d13e18"><h1 class="ChapTitleNonprintingctnp" data-displayheader="no"><span href="#/toc01" title="Link target outside of Sample">Newsletter Sign-up</span></h1>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a class="spanhyperlinkurl" href="#/part01#d1e884" id="beginreading">Begin Reading</a></p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><span class="spanhyperlinkurl" href="#/toc01#z_TOC" id="toc" title="Link target outside of Sample">Table of Contents</span></p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><span class="spanhyperlinkurl" href="#/app04#d1e13998" id="abouttheauthor" title="Link target outside of Sample">About the Authors</span></p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a class="spanhyperlinkurl" href="#/copyrightpage01#d1e472" id="copyright-page">Copyright Page</a></p>
<p style="text-align: center; text-indent: 0; font-weight: bold; line-height: 1.3em; margin-top: 4em">Thank you for buying this Tor Books ebook.</p>
<p style="text-align: center; text-indent: 0; line-height: 1.3em;">To receive special offers, bonus content, and info on new releases and other great reads, sign up for our newsletters.</p>
<p style="text-align: center; text-indent: 0; line-height: 1.5em;"><a href="http://us.macmillan.com/newslettersignup?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=wildcardstrust_newslettersignup_macdotcom&amp;utm_campaign=9780765396402" target="_blank"><img alt="signup button" height="67" src="NewsletterSignup.jpg" width="112"/></a></p>
<p style="text-align: center; text-indent: 0; line-height: 1.3em; margin-bottom: 1em;">Or visit us online at <a href="http://us.macmillan.com/newslettersignup?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=wildcardstrust_newslettersignup_macdotcom&amp;utm_campaign=9780765396402" target="_blank">us.macmillan.com/newslettersignup</a></p></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface01.vue?fae5d5d8